<template>
    <div class="swiper-slide">

        <div class="image-area float-left">
            <router-link :to="{name: 'single', params: {language: language, slug: item.slug}}">
                <img v-if='language === "nl" && item.acf.image'
                     :src="item.acf.image.sizes['grid-large']">
                <img v-if='language === "en" && item.acf.image_en'
                     :src="item.acf.image_en.sizes['grid-large']">
            </router-link>
        </div>

        <div class="text-area float-left">

            <div class='grid-item'>

                <div class='tags'>
                    <dsTagItemInline v-for='tag in item.tags'
                                     :tag="tag"
                                     :tags='tags'
                                     :language='language'></dsTagItemInline>
                </div>

                <div class='author small-text bold'>
                    <span>{{ item.acf.author }}</span>
                </div>

                <router-link :to="{name: 'single', params: {language: language, slug: item.slug}}"
                             class='title roman'>
                    <span v-if='language === "nl"'
                          v-html='item.title.rendered'></span>
                    <span v-if='language === "en"'
                          v-html='item.acf.title_en'></span>
                </router-link>

                <div class='description featured-description secondary-color small-text '>
                    <div v-if='language === "nl"'
                         v-html='item.acf.excerpt'></div>
                    <div v-if='language === "en"'
                         v-html='item.acf.excerpt_en'></div>
                </div>

            </div>

        </div>

    </div>
</template>

<script>
import dsTagItemInline from './dsTagItemInline'
export default {
  name: 'dsFeaturedItem',
  props: ['language', 'item', 'tags'],
  components: {
    dsTagItemInline
  }
}
</script>

<style lang='scss'scoped>
@import '../styles/helpers/_mixins.scss';
@import '../styles/responsive/_manager.scss';
@import '../styles/_variables.scss';
@import '../styles/_space.scss';
@import '../styles/_color.scss';
@import '../styles/_typography.scss';
@import '../styles/vendor/swiper.css';

.float-left {
  float: left;
}

img {
  background: $high-light;
  height: 100%;
  width: 100%;
}

.image-area {
  width: 2 * $column + $margin;
  height: 41 * $baseline;
  @include screen-size ('medium') {
    width: $column;
    height: 20 * $baseline;
  }
  img {
    width: 100%;
    opacity: 0.6;
    height: 100%;
    filter: grayscale(1);
    @include screen-size ('medium') {
      height: 20 * $baseline;
    }
    object-fit: cover;
    object-position: center;
  }
  &:hover {
    // background: $high-light;
    img {
      opacity: 0.9;
      filter: none;
      cursor: pointer;
      mix-blend-mode: multiply;
    }
  }
  a {
    border: 0;
  }
  @include screen-size ('x-small') {
    width: 100%;
    margin-top: 30px;
  }
}

.text-area {
  height: 100%;
  margin-left: $margin;
  width: $column;
  @include screen-size ('x-small') {
    margin-left: 0;
    margin-top: $baseline;
  }
  .grid-item {
    .tags {
      @include screen-size ('medium') {
        display: none;
      }
    }
  }
  @include screen-size ('x-small') {
    width: 100%;
  }
}

.featured-description {
  margin-top: 2 * $baseline;
}

.title {
  @include screen-size ('x-small') {
    width: 280px !important;
    white-space: normal;
  }
  margin-bottom: 1 * $baseline;
  span {
    line-height: 3 * $baseline;
    position: relative;
    top: -1px;
    font-size: $large-text;
  }
}
</style>



// WEBPACK FOOTER //
// dsFeaturedItem.vue?72499f0e